/**
 * Theme Requirements Aggregation for Repli Sandbox Preferred
 * 
 * Extends the base preferred theme requirements with Repli Sandbox Preferred specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-preferred/requirements';

/**
 * Repli Sandbox Preferred component requirement overrides.
 * Add requirements for any override components here.
 */
const replisandboxpreferredOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Repli Sandbox Preferred theme.
 * Inherits from preferred theme and overrides with Repli Sandbox Preferred components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...replisandboxpreferredOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
